import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Slide, toast } from 'react-toastify'

const TOAST_ID = 'art-pending-toast'

export const showArtPendingToast = () => {
  if (toast.isActive(TOAST_ID)) return

  toast(
    'Sua arte continua sendo gerada em segundo plano! Avisaremos quando terminar.',
    {
      position: 'top-center',
      transition: Slide,
      autoClose: 8000,
      hideProgressBar: true,
      closeButton: false,
      toastId: TOAST_ID,
      bodyStyle:{
        fontFamily:'Poppins',
        fontSize:'16px',
      }
    }
  )
}

export const SnackBar = ({ isOpen }) => {
  useEffect(() => {
    if (isOpen) {
      showArtPendingToast()
    }
  }, [isOpen])

  return null
}

SnackBar.propTypes = {
  isOpen: PropTypes.bool,
}

